<template>
  <v-menu
    v-if="$currentUser"
    :close-on-content-click="false"
    offset-y
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="white"
        icon
        v-on="on"
      >
        <v-avatar
          :size="44"
        >
          <img
            v-if="$currentUser.photoURL"
            :src="$currentUser.photoURL"
          >

          <span v-else-if="$currentUser.displayName">
            {{ $currentUser.displayName.split(' ').slice(0, 2).map(x => x[0]).join('') }}
          </span>

          <span
            v-else
            style="font-size:1.4rem"
          >
            🧑
          </span>
        </v-avatar>
      </v-btn>
    </template>

    <v-list subheader>
      <!-- Account Info -->
      <v-list-item two-line>
        <v-list-item-content>
          <v-list-item-title>
            {{ $currentUser.displayName }}
          </v-list-item-title>

          <v-list-item-subtitle>
            {{ $currentUser.email }}
          </v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-action class="ml-0">
          <v-tooltip left>
            <template #activator="{ on }">
              <v-btn
                color="error"
                icon
                @click="signOut"
                v-on="on"
              >
                <v-icon>mdi-power</v-icon>
              </v-btn>
            </template>

            <span>Sign out</span>
          </v-tooltip>
        </v-list-item-action>
      </v-list-item>

      <v-divider />

      <v-subheader>
        VJAGO SOCIAL
      </v-subheader>

      <div class="d-flex px-4 pb-3 justify-space-around">
        <v-btn
          icon
          color="#4267B2"
          href="https://www.facebook.com/Vjago-104804060958321"
          target="_blank"
        >
          <v-icon>
            mdi-facebook-box
          </v-icon>
        </v-btn>

        <v-btn
          icon
          color="#E1306C"
          href="https://www.instagram.com/vjagotravel"
          target="_blank"
        >
          <v-icon>
            mdi-instagram
          </v-icon>
        </v-btn>

        <v-btn
          icon
          color="#00ACEE"
          href="https://www.twitter.com/vjagotravel"
          target="_blank"
        >
          <v-icon>
            mdi-twitter
          </v-icon>
        </v-btn>
      </div>

      <v-divider />

      <!-- Website links -->
      <v-list-item
        href="https://vjago.com/terms"
        target="_blank"
      >
        <v-list-item-title>Terms &amp; Conditions</v-list-item-title>
      </v-list-item>

      <v-list-item
        href="https://vjago.com/privacy"
        target="_blank"
      >
        <v-list-item-title>Privacy Policy</v-list-item-title>
      </v-list-item>

      <v-list-item
        href="mailto:info@vjago.com"
        target="_blank"
      >
        <v-list-item-title>Contact Us</v-list-item-title>
      </v-list-item>

      <div
        class="caption text-center grey--text"
      >
        Vjago v{{ version }}
      </div>
    </v-list>
  </v-menu>

  <dialog-login v-else />
</template>

<script>
import * as firebase from 'firebase/app'

import DialogLogin from '@/components/DialogLogin'
import { version } from '@/../package.json'

export default {
  components: {
    DialogLogin
  },
  data () {
    return {
      version
    }
  },
  methods: {
    async signOut () {
      try {
        await firebase.auth().signOut()
        window.location.href = '/'
      } catch (e) {
        console.error(e)
      }
    }
  }
}
</script>

<style>

</style>
